export const REDIRECTED = '@@mah-routes/REDIRECTED';
export const SET_REDIRECT_URL = '@@mah-routes/SET_REDIRECT_URL';
export const TOGGLE_MENU = '@@mah-routes/TOGGLE_MENU';